export default {
    "WelcomeHome": "Bienvenido a casa",
    "FinancialGuide": "Orientación financiera para su hogar",
    "GetSmarterSubText":"Aprenda más sobre su mayor activo. Comprenda el valor de su vivienda, descubra los ahorros ocultos y cree un patrimonio a largo plazo con nuestro completo conjunto de herramientas financieras para ser propietario de una vivienda.",
    "Address":"Ingresa su dirección",
    "GetStarted":"Empezar",
    "HomeWorth":"SABER LO QUE VALE SU CASA",
    "HomeMarketValue":"Controle el valor de mercado de su casa",
    "Valuation":"Reciba una valoración gratuita, basada en datos, de su vivienda a partir de información actualizada del mercado y de ventas de viviendas comparables.",
    "MortgageTracking":"SEGUIMIENTO DE LA HIPOTECA Y DEL PATRIMONIO",
    "MortgageBalance":"Seguimiento de los saldos de capital e hipotecas",
    "TrackHome":"Controle el valor de su vivienda, optimice su hipoteca y aprenda a crear riqueza a largo plazo.",
    "HomeOwnerTools":"HERRAMIENTAS PARA SER PROPIETARIO DE UNA VIVIENDA CON ÉXITO",
    "PersonalizedAlerts":"Obtenga alertas de mantenimiento personalizadas",
    "PersonalizedMaintanance": "Reciba notificaciones de mantenimiento, haga un seguimiento de su progreso y contectarse con los mejores profesionales para su hogar.",
    "PlanFuture": "PLANIFIQUE PARA EL FUTURO",
    "ExpertGuidance": "Desbloque la guía de expertos para cada paso",
    "PersonalizedSuggestions": "Sugerencias personalizadas para ayudarle a ahorrar en impuestos, seguros e hipotecas.",
    "LifeInvestment": "Gestionar la mayor inversión de la vida",
    "YourHome": "Con orientación personalizada y herramientas intuitivas, puede tomar decisiones informadas sobre el mayor activo de la vida: su hogar.",
    "MeetAgent": "Reúnase con un agente de bienes raíces hoy mismo"

}